import React, { useContext, useEffect, useState } from 'react'
import { Select, Spin, App, SelectProps } from "antd"
import { API, Enum } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios"

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import { AntTableParams } from "../../../interfaces/ant"
import type { TablePaginationConfig } from 'antd/es/table'

const { Pages: { UserManagement: { Role: RoleLanguage } }, Share, Validation, Message: MessageLanguage } = language
const { USER_MANAGEMENT_ROLE_PERMISSION_ALL, USER_MANAGEMENT_ROLE_PERMISSION_UPDATE } = API
const { Message } = Enum

interface PermissionType {
    id: string,
    name: string,
    caption: string,
}

export default function AddPermission(props: { Form: any, form: any, record: { id: string }|null, getRoles: (params: AntTableParams) => void, paginationRole: TablePaginationConfig, getPermissions: (params: AntTableParams) => void, sort: string|false|null|undefined }) {
    const { Form, form, record, getRoles, paginationRole, getPermissions, sort } = props

    const { axios } = useContext(AxiosContext)
    const [permissions, setPermissions] = useState<SelectProps[]>([]);
    const [loadingRecord, setLoadingRecord] = useState<boolean>(true);
    const { message } = App.useApp();

    useEffect(() => {
        form.resetFields()
        initialAPI().then(response => response)
    }, []);

    const initialAPI = async () => {
        setLoadingRecord(true)
        record && await getRolePermissions(record?.id)
        setLoadingRecord(false)
    }

    const getRolePermissions = async (id: string) => axios.post(USER_MANAGEMENT_ROLE_PERMISSION_ALL + id).then((response: { data: PermissionType[] }) => {
        const { data: permissions } = response
        setPermissions(permissions.map(({ id, name}) => ({ label: name, value: id })))
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    })

    const onFinish = ((values: {}) => {
        setLoadingRecord(true)
        axios.patch(USER_MANAGEMENT_ROLE_PERMISSION_UPDATE + record?.id, values).then((response: {}) => {
            message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
            form.resetFields()
            initialAPI().then(response => response)
            const { current: currentRole, pageSize: pageSizeRole } = paginationRole
            getRoles({ page: currentRole, limit: pageSizeRole, sort })
            getPermissions({ page: 1, limit: 10 })
        }).catch((error: AxiosError) => {
            const { response: { data } } = error;
            // @ts-ignore
            message.error(MessageLanguage[data.message]).then(response => response)
            setLoadingRecord(false)
        })
    })

    return (
        <Spin spinning={loadingRecord} tip={Share.loading} size="large">
            <Form form={form} name="add-permission" onFinish={onFinish} style={{ margin: '25px 0 10px 0'}}>
                <Form.Item
                    label={RoleLanguage.permissions}
                    name="permissions"
                    hasFeedback
                    rules={[
                        { required: true, message: `${RoleLanguage.permissions} ${Validation.required}` },
                    ]}
                >
                    <Select
                        showSearch
                        allowClear
                        mode="multiple"
                        optionFilterProp="label"
                        placeholder={Share.pleaseSelectedRecords}
                        options={permissions}
                    />
                </Form.Item>
        </Form>
        </Spin>
    )
}
